export default "__VITE_ASSET__Dvk40ur$__"